export default __webpack_public_path__ + "static/media/NZ.9cd4a686.svg";